import React, { useState, useEffect } from 'react';
import IconLabel from 'ui/IconLabel';
import PageContainer from 'ui/PageContainer';
import PaperContainer from 'ui/PaperContainer';
// import SimpleTable from 'ui/Table';
// import Decimal from 'ui/formats/Decimal';
// import Money from 'ui/formats/Money';
// import Percent from 'ui/formats/Percent';
import TransactionFilters from 'ui/transactions/Filters';
import TransactionsHistory from 'ui/transactions/TransactionsHistory';

import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// import { CalendarToday } from '@material-ui/icons';
import formatters from '../../../../formatters';
import { getTransactions } from '../services';
import { withStyles } from '@material-ui/core';

// const AmountInfo = ({ amount, currency }) => {
//     return (
//         <React.Fragment>
//             <Typography align="right" variant="h4">
//                 <Money amount={amount} currency={currency} />
//             </Typography>
//             <Typography color="textSecondary" variant="body2">
//                 Next payment as of today
//             </Typography>
//         </React.Fragment>
//     );
// };

const styles = theme => ({
    noData: {
        padding: `${theme.spacing(2)}px`,
        textAlign: 'center',
    },
});

const Transactions = ({ classes }) => {
    const [filterDateRange, setFilterDateRange] = useState('last_3_months');
    const [summary, setSummary] = useState({});
    const [billings, setBillings] = useState([]);
    // const [accountSummary, setAccountSummary] = useState([]);
    // const [total, setTotal] = useState([]);

    useEffect(async () => {
        const { summary, billings } = await getTransactions();

        setSummary(summary);
        setBillings(billings);
    }, []);

    const fetchTransactions = async filter => {
        const { billings } = getTransactions({ show: filter });

        setBillings(billings);
        setFilterDateRange(filter);
    };

    // const moneyFormater = formatters.getCurrencyFormatter(
    //     'en-us',
    //     summary.currency
    // );

    const havePrevTransactions = billings.length;
    return (
        <React.Fragment>
            <PaperContainer
                title="Account summary"
                subtitle={`Your next automatic payment will be on ${formatters.date(
                    summary.next_billing_data,
                    'MMM D'
                )}`}
            >
                <p>{summary.plan_name}</p>
                <IconLabel label={summary.plan_description} />
            </PaperContainer>

            <PageContainer>
                <TransactionFilters
                    selectedOption={filterDateRange}
                    options={{
                        last_3_months: 'Last 3 months',
                        last_6_months: 'Last 6 months',
                        last_12_months: 'Last 12 months',
                        all: 'All',
                    }}
                    onChange={fetchTransactions}
                />
                {havePrevTransactions ? (
                    <>
                        {billings.map(b => {
                            const title = `${formatters.date(
                                b.date,
                                'MMM 1-D YYYY'
                            )}`;

                            return (
                                <TransactionsHistory
                                    key={b.date}
                                    title={title}
                                    amount={Number(b.total_amount)}
                                    currency={summary.currency}
                                    data={b.billings.map(
                                        ({
                                            description,
                                            users_count,
                                            amount,
                                        }) => {
                                            return [
                                                b.date,
                                                users_count,
                                                description,
                                                Number(amount),
                                            ];
                                        }
                                    )}
                                    payment={b.payment}
                                />
                            );
                        })}
                    </>
                ) : (
                    <Paper elevation={1} className={classes.noData}>
                        <Typography>
                            You don't have any transactions yet.
                        </Typography>
                    </Paper>
                )}
            </PageContainer>
        </React.Fragment>
    );
};

export default withStyles(styles)(Transactions);
